var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E8F8BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9146 18.8574C12.9146 16.6483 14.7054 14.8574 16.9146 14.8574H30.7895V31.6641H12.9146V18.8574Z",
    fill: "#194142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9146 33.9053H30.7895V50.712H16.9146C14.7054 50.712 12.9146 48.9211 12.9146 46.712V33.9053Z",
    fill: "#194142"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0239 14.8574H46.8988C49.108 14.8574 50.8988 16.6483 50.8988 18.8574V31.6641H33.0239V14.8574Z",
    fill: "#194142"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0239 33.9053H50.8988V46.712C50.8988 48.9211 49.108 50.712 46.8988 50.712H33.0239V33.9053Z",
    fill: "#194142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.f6717e55718a609d7d4c29e7203a5906.svg";
export { ForwardRef as ReactComponent };